module.exports = "/_next/static/images/1-bacba42b6f812dc51531d8ea4e2d0796.jpg";